import { business } from './business';

// GERIYE UYUMLULUK: yeni kod business.ts kullanmali
export const contactConfig = {
  phone: business.phone.raw,
  phoneDisplay: business.phone.display,
  whatsapp: business.phone.raw,
  whatsappMessage: 'Merhaba, kepenk hizmetleri hakkında bilgi almak istiyorum.',
  email: business.email,
  address: 'İstanbul - Merkez',
};
